export * from './angularx-qrcode.component';
